<app-loader [showLoader]="showLoader$"></app-loader>
<router-outlet></router-outlet>
